module.exports = __webpack_public_path__ + "assets/bbb2ae402c87e74999dff790a4945b32.mp3";